/**
 * @file 收银模块相关接口
 */


import * as tools from '@/tools/tools.js';


// 登录接口
export async function loginApi(that, data) {
	const result = await that.$fetch({
		method: 'post',
		url: '/syapi/cashier/login',
		data
	});

	console.log('/syapi/cashier/login result', result);

	if (that.checkNetworkSuccessFn(result)) {
		return {
			token: tools.objectGetString(result.data, 'token'),
			name: tools.objectGetString(result.data, 'info.name')
		};
	}
	return result;
}








// 获取ai称初始化密钥
export async function scaleSecretKeyApi(that) {

	const result = await that.$fetch({
		method: 'post',
		resultDataType: 'Array',
		url: '/syapi/config/appointConfig',
		data: {
			names: [
				'sf_scale_app_auth', // 收银ai称密钥
			],
		}
	});

	console.log('/syapi/config/appointConfig result', result);

	if (that.checkNetworkSuccessFn(result)) {

		const getValFn = key => {

			const list = result.data;

			let index = -1;
			for (const i in list) {
				if (list[i].name == key) {
					index = i;
					break;
				}
			}
			if (index < 0) return '';
			return tools.objectGetString(list[index], 'value');
		}
		return getValFn('sf_scale_app_auth');
	}
	return result;
}








/**
 * @description 获取权限列表数据
 */
export const permissionListApi = async that => {
	const result = await that.$fetch({
		resultDataType: 'Array',
		method: 'post',
		url: '/syapi/Config/menu'
	});
	console.log('/syapi/Config/menu result', result);
	if (that.checkNetworkSuccessFn(result)) {
		return result.data
	}
	return result;
}


// WEBPACK FOOTER //
// ./src/apis/apis.js